interviews = {};

interviews.grid = {
    init: function () {
        interviews.grid.loadNewsGrid();
        interviews.grid.loadWidth();
   },
    loadNewsGrid: function () {
        let $newsGrid = $('.js-interviewsCarousel');
        let elementsToShow = $newsGrid.data('elements') || 3.5;
        let elementsToShowMobile = $newsGrid.data('elements-mobile') || 1.15;
        console.log('Elements to show', elementsToShow, elementsToShowMobile);

        $newsGrid.on('init', function (event, slick) {
            $newsGrid.addClass('isLoaded');
        });

        $newsGrid.slick({
            arrows: true,
            dots: false,
            infinite: false,
            speed: 400,
            slidesToShow: elementsToShow,
            slidesToScroll: 1,
            appendArrows: '.js-interviewsCarouselArrows',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 911,
                    settings: {
                        slidesToShow: elementsToShowMobile,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },
    loadWidth: function () {
        if ($(window).width() > 911) {
            let $interviewCarouselElem = $('#interview-carousel');
            let width = $(window).width() - $interviewCarouselElem.offset().left;
            $interviewCarouselElem.css('width', width);
        }
    }
};

interviews.init = function () {

    interviews.grid.init();
};

interviews.binds = function () {
    //news.binds();
    $(window).on('resize', function() {
        interviews.grid.loadWidth();
    });
};

$(document).ready(function () {
    interviews.binds();
    interviews.init();
});